<template>
  <base-layout>
    <div class="common-page" v-if="!loading">
      <div class="container-fluid">
        <dx-choose-players @change="setPlayers" />
        <dx-choose-level @change="setLevel" />
        <dx-choose-tips @change="setTips" />
        <div class="text-center">
          <dx-button success large @click.native="onStartGame" v-if="!starting">
            {{ $t('start') }}
          </dx-button>
          <dx-spinner :active="starting" />
        </div>
      </div>
    </div>
  </base-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { BaseLayout } from '../layouts'
import {
  DxChoosePlayers,
  DxChooseLevel,
  DxChooseTips,
  DxButton,
  DxSpinner
} from '../components'
export default {
  name: 'new-game',
  components: {
    BaseLayout,
    DxChoosePlayers,
    DxChooseLevel,
    DxChooseTips,
    DxButton,
    DxSpinner
  },
  data () {
    return {
      players: 3,
      level: 'medium',
      tips: 10,
      loading: false,
      starting: false
    }
  },
  methods: {
    ...mapActions(['startGame']),
    setPlayers (players) {
      this.players = players
    },
    setLevel (level) {
      this.level = level
    },
    setTips (tips) {
      this.tips = tips
    },
    onStartGame () {
      let settings = {
        players: this.playerAvatars,
        level: this.level,
        tips: this.tips
      }
      this.starting = true
      this.startGame(settings).then(() => {
        this.starting = false
        this.$router.push({ name: 'game' })
      })
    }
  },
  computed: {
    ...mapGetters({
      playerAvatars: 'getPlayerAvatars'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/NewGame.vue